import React from 'react';

const ButtonHallow = ({ content = '',className = '',style = {},onClick = () => {},...rest}) => {
  return (
    <button 
      className={`hallow-button ${className}`} 
      style={style} 
      onClick={onClick} 
      {...rest}
    >
      {content}
    </button>
  );
};

export default ButtonHallow;
